<template>
  <v-container fluid class="pa-7">
    <header-component class="pb-4" :title="$vuetify.lang.t('$vuetify.customers.createCustomer')"> </header-component>

    <v-row class="pt-5">
      <v-col cols="12" lg="5">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.customers.cardId')"
          outlined
          single-line
          hide-details
          v-model="loyaltyCardId"
          clearable
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="5">
        <QrCodeReaderComponent @decode="decode($event)" :is-order="false" width="100%" height="56" class="w-100" />
      </v-col>
    </v-row>

    <v-row class="pt-8">
      <v-col cols="12" lg="5">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.basic.name')"
          outlined
          single-line
          hide-details
          v-model="formData.first_name"
          clearable
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="5">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.basic.surname')"
          outlined
          single-line
          hide-details
          v-model="formData.last_name"
          clearable
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="5">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.basic.email')"
          outlined
          single-line
          hide-details
          v-model="formData.email"
          clearable
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="5" lg="2">
        <v-select
          :items="countries"
          :value="defaultDialCode"
          @change="selectDialCode($event)"
          outlined
          hide-details
          autocomplete="off"
        >
          <template v-slot:selection="data">
            <country-flag rounded :country="data.item.countryId" /> {{ data.item.value }}
          </template>
          <template v-slot:item="data">
            <country-flag rounded :country="data.item.countryId" /> {{ data.item.value }}
          </template>
        </v-select>
      </v-col>
      <v-col cols="7" lg="3">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.basic.phone')"
          outlined
          single-line
          hide-details
          v-model="formData.phone"
          clearable
        />
      </v-col>

      <v-col cols="12">
        <v-checkbox
          class="mt-0"
          v-model="isSubscribed"
          hide-details
          label="Odběr newsletter"
          @click="resetReferral"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" lg="5">
        <v-text-field
          label="Kód na extra kredity"
          outlined
          single-line
          hide-details
          v-model="referralCode"
          :disabled="!isSubscribed"
          clearable
        />
      </v-col>

      <v-col cols="12">
        <v-checkbox class="mt-0" v-model="gdpr">
          <template slot="label">
            Souhlas s
            <a @click.stop target="_blank" class="ml-2" href="https://www.genesis-eshop.cz/vseobecne-obchodni-podminky">
              obchodními podmínkami
            </a>
            <span class="mx-2">a</span>
            <a @click.stop target="_blank" href="https://www.genesis-eshop.cz/podminky-ochrany-osobnich-udaju">
              podmínkami ochrany osobních údajů </a
            >.
          </template>
        </v-checkbox>
      </v-col>
    </v-row>

    <footer-component>
      <template v-slot:actions>
        <div class="d-flex footer-buttons">
          <v-btn class="mr-3" @click="$router.push({ name: 'customers' })">
            <span>
              {{ $vuetify.lang.t('$vuetify.basic.cancel') }}
            </span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" color="primary" :disabled="createPending" @click="preSendFormRegistration">
            <span v-if="!createPending">
              {{ $vuetify.lang.t('$vuetify.basic.create') }}
            </span>
            <div v-else class="d-flex align-center justify-center h-100">
              <v-progress-circular :size="25" color="white" indeterminate :width="3" />
            </div>
          </v-btn>
        </div>
      </template>
    </footer-component>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CountryFlag from 'vue-country-flag';

import HeaderComponent from '../../components/layout/HeaderComponent.vue';
import FooterComponent from '../../components/layout/FooterComponent.vue';
import QrCodeReaderComponent from '../../components/global/QrCodeReaderComponent.vue';

import { LoyaltyProgramCardsApiService } from '@/common/services/loyalty-program-cards.api.service';
import { CustomersCommentsApiService } from '@/common/services/customers-comments.api.service';
import { StoresCustomersApiService } from '@/common/services/stores-customers.api.service';
import { CreditsCouponsApiService } from '@/common/services/credits-coupons.api.service';
import { CreditCouponStatusApiService } from '@/common/services/credit-coupon-status.api.service';

export default {
  components: {
    HeaderComponent,
    FooterComponent,
    QrCodeReaderComponent,
    CountryFlag,
  },

  data() {
    return {
      formData: {
        id: null,
        is_subscribed: false,
      },
      createPending: false,
      countries: [
        { text: '+43', value: '+43', countryId: 'AT' },
        { text: '+420', value: '+420', countryId: 'CZ' },
        { text: '+49', value: '+49', countryId: 'DE' },
        { text: '+48', value: '+48', countryId: 'PL' },
        { text: '+421', value: '+421', countryId: 'SK' },
      ],
      dialCode: null,
      gdpr: false,
      loyaltyCardId: null,
      customerComment: null,
      referralCode: null,
      isSubscribed: true,
    };
  },

  computed: {
    ...mapGetters({
      storeData: 'users/getStoreData',
      user: 'auth/getUser',
    }),

    defaultDialCode() {
      return '+420';
    },
  },

  methods: {
    ...mapActions({}),
    selectDialCode(e) {
      this.dialCode = e;
    },

    resetReferral() {
      this.referralCode = null;
    },

    async preSendFormRegistration() {
      if (this.createPending) {
        return;
      }

      try {
        this.createPending = true;

        if (this.isSubscribed && this.referralCode) {
          await CreditCouponStatusApiService.post({
            code: this.referralCode,
          });
        }

        await this.createCustomer();
      } catch (response) {
        this.$alertError('Kreditový kód se nepodařilo uplatnit');
      } finally {
        this.createPending = false;
      }
    },

    async createCustomer() {
      if (this.loyaltyCardId) {
        const canUseLoyaltyCard = await this.checkCanUseLoyaltyCard();

        if (!canUseLoyaltyCard) {
          this.createPending = false;
          return;
        }
      }

      if (!this.gdpr) {
        this.$alertError(this.$vuetify.lang.t('$vuetify.errors.gdpr'));

        this.createPending = false;
        return;
      }

      this.createPending = true;

      if (!this.formData.first_name || !this.formData.last_name || !this.formData.phone || !this.formData.email) {
        this.$alertError(this.$vuetify.lang.t('$vuetify.errors.allFields'));
        this.createPending = false;
        return;
      }

      const password = (Math.random() + 1).toString(36).substring(2);

      const data = JSON.parse(JSON.stringify(this.formData));

      data.phone = this.dialCode ? this.dialCode + this.formData.phone : this.defaultDialCode + this.formData.phone;
      data.id = data.id === '' ? null : data.id;
      data.is_active = true;
      data.password = password;
      data.password_confirmation = password;
      data.bank_code = null;
      data.bank_account_number = null;
      data.bank_swift_code = null;
      data.bank_account_iban = null;
      data.is_blocked = false;
      data.customer_groups = [];
      data.customer_accounts = [];
      data.gender_oriented_product_preference = 0;
      data.restrict_to_country_id = null;
      data.stock_id = this.storeData.id;
      data.user_id = this.user.attributes.attributes.id;
      data.code = this.loyaltyCardId;
      data.is_subscribed = this.isSubscribed;

      try {
        const response = await StoresCustomersApiService.post(data);
        const customer = response.getItem();

        this.$alertSuccess(this.$vuetify.lang.t('$vuetify.messages.successfulyCreated'));

        await this.applyCreditVoucher(customer.id);

        if (this.loyaltyCardId) {
          await this.addLoyaltyCardCustomerComment(customer.id);
        } else {
          await this.$router.push({ name: 'customers', params: { customerId: customer.id } });
        }
      } catch (error) {
        this.$alertError(error.getFirstValidationErrorMessage() || error.getMessage());
      }

      this.createPending = false;
    },

    async applyCreditVoucher(customerId) {
      if (!this.referralCode) {
        return;
      }

      try {
        await CreditsCouponsApiService.post({
          customer_id: customerId,
          code: this.referralCode,
        });

        this.$alertSuccess('Kreditový kód byl uplatněn');
      } catch (response) {
        let errorMessage = '';

        if (typeof response.getMessage() !== 'undefined') {
          errorMessage = response.getMessage();
        } else {
          errorMessage = 'Neočekávaná chyba';
        }

        this.$alertError(errorMessage);
      }
    },

    async checkCanUseLoyaltyCard() {
      const card = await this.searchLoyaltyCardByCode(this.loyaltyCardId);

      if (!card) {
        this.$alertError(this.$vuetify.lang.t('$vuetify.messages.cardNotExist'));

        return false;
      }

      if (card.customerId) {
        this.$alertError(this.$vuetify.lang.t('$vuetify.messages.cardAlreadyUsed'));

        return false;
      }

      return true;
    },

    async searchLoyaltyCardByCode(cardCode) {
      try {
        return (
          await LoyaltyProgramCardsApiService.getAll(builder => {
            builder.whereEquals('code', cardCode);
          })
        ).getItems()[0];
      } catch (e) {
        console.error(e);
      }
    },

    async addLoyaltyCardCustomerComment(customerId) {
      try {
        this.customerComment =
          this.$vuetify.lang.t('$vuetify.customers.autoComments.card') +
          this.loyaltyCardId +
          this.$vuetify.lang.t('$vuetify.customers.autoComments.addedWithRegistration');

        await CustomersCommentsApiService.post(customerId, {
          comment: this.customerComment,
        });

        this.customerComment = null;

        await this.$router.push({ name: 'customers', params: { customerId: customerId } });
      } catch (error) {
        this.$alertError(error.getFirstValidationErrorMessage() || error.getMessage());

        await this.$router.push({ name: 'customers', params: { customerId: customerId } });
      }
    },

    decode(e) {
      setTimeout(() => {
        this.loyaltyCardId = e;
        this.$forceUpdate();
      }, 100);
    },
  },

  created() {
    // prefill the customer id if it was included in the url params
    if (this.$route.params.id) {
      this.loyaltyCardId = this.$route.params.id;
    }
  },
};
</script>

<style scoped>
.flag {
  display: inline-block;
  margin-left: -1rem;
  margin-right: -0.6rem;
}
</style>
